// This plugin is used to load the ProductGridbox assets for Storybook
export default defineNuxtPlugin(async () => {
  // Check if the page is running in Storybook
  if (!import.meta.env.STORYBOOK) {
    return;
  }

  try {
    const html = await $fetch<string>("/p/fragment/ProductGridbox.html");

    const parser = new DOMParser();
    const document = parser.parseFromString(html, "text/html");

    const links = Array.from(document.querySelectorAll("link")).map((link) => ({
      rel: link.getAttribute("rel")!,
      href: link.getAttribute("href")!,
      type: "text/css",
      defer: true,
    }));

    const scripts = Array.from(document.querySelectorAll("script")).map((script) => {
      return {
        src: script.getAttribute("src")!,
        type: "module",
        defer: true,
      };
    });

    useHead({
      link: links,
      script: scripts,
    });
  } catch (error) {
    console.error("Error loading ProductGridbox assets in Storybook:", error);
  }
});
